{{#> elements/_dt}}
  {{> elements/_label }}
{{/elements/_dt}}
{{#each revealing_options}}
  <dd>
    <input data-behavior="revealing-radio" data-revealing-group="{{../id}}" type="radio" name="{{../prefix}}[{{../name}}]" {{#unless @index}}checked{{/unless}} id="{{../id}}_{{parameterize this.value}}" value="{{this.value}}" />
    <label for="{{../id}}_{{parameterize this.value}}">{{this.value}}</label>
  </dd>
{{/each}}
{{#each revealing_options}}
  <div data-behavior="revealing-radio-content" data-revealing-group="{{../id}}" id="{{../id}}_{{parameterize this.value}}_revealing_content">
    {{{this.content}}}
  </div>
{{/each}}
